module.exports = __webpack_public_path__ + "img/menu-badge-icon-white.a4d433fc.png";